import { TRANSLATION_KEYS } from "./translationKeys"

/**
 * For Dynamic Text -
 * Please use - string {param}
 * @example - Hello {name}
 */

export const TRANSLATIONS = {
  common: {
    [TRANSLATION_KEYS.REVIEW_TITLE]: "Ratings & Reviews",
    [TRANSLATION_KEYS.TOTAL_RATING_COUNT]: "{ratingsCount} ratings",
    [TRANSLATION_KEYS.WRITE_REVIEW_TITLE]: "Review this product",
    [TRANSLATION_KEYS.WRITE_REVIEW_HELP]:
      "Help others make an informed decision!",
    [TRANSLATION_KEYS.WRITE_REVIEW_CTA]: "Write a review",
  },
  jiomart: {
    greeting: "Hello, {name}!",
  },
  netmeds: {
    greeting: "Hello, {name}!",
  },
  tira: {
    greeting: "Hello, {name}!",
  },
}
